// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/32521
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 32521 
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils'
export const PageId = Object.freeze({
  Activity_BestSellersHome: 'Activity_BestSellersHome'
})

interface IPVTrackParamsRecord {
  /** 排行榜首页 */
Activity_BestSellersHome: undefined
}

const sendPv = {
  /** PV-排行榜首页 */
Activity_BestSellersHome: () => {
    eventTrackingUtils.submitPV({page_id:PageId.Activity_BestSellersHome});
  },
}

interface IExpoTrackParamsRecord {
  /** 榜单楼层查看更多曝光 */
Activity_BestSellersHome_LookMoreExpo: {
/** 类型  */
type: string,
/** 榜单id  */
rankId: string,
/** 榜单名称  */
rankName: string,
/** 评分数量  */
scoreNum: string,
/** 分类等级  */
cateLevel: number,
/** tab名称  */
tabName: string,
/** 商品id  */
skuid: Array<string>}
  /** 榜单楼层曝光 */
Activity_BestSellersHome_RankCard_Expo: {
/** 榜单id  */
rankId: string,
/** 榜单名称  */
rankName: string,
/** 位置  */
index: number,
/** 类型  */
type: string,
/** 分类等级  */
cateLevel: number,
/** 商品id  */
skuid: Array<string>,
/** tab名称  */
tabName: string,
/** 评分数量  */
scoreNum: string}
  /** 翻页查看更多按钮曝光 */
Activity_BestSellersHome_ViewMoreExpo: {
/** 页码  */
page: number}
  /** 榜单首页tab曝光 */
Activity_BestSellersHome_Tab_Expo: {
/** tab名称  */
tabName: Array<string>}
  /** 购物车按钮曝光 */
Activity_BestSellersHome_Cart_Ep: {
/** 榜单排名  */
rank_no: string,
/** 榜单id  */
rankid: string,
/** 榜单名称  */
rank_name: string,
/** 类型  */
type: string,
/** 分类等级  */
cateLevel: number}
  /** 商品曝光 */
Activity_BestSellersHome_ProductExpo: {
/** 商品id  */
skuid: string,
/** 第一价格金额  */
firprice: number,
/** 第一价格分类 1-新人价,2-重逢价,3-粉丝价,4-闪购价,5-学生价,6-企业价,7-拼购价,8-家庭价,9-plus价,10-合约价,11-到手价,12-店铺会员价-L1会员,13-店铺会员价-L2会员,14-店铺会员价-L3会员,15-店铺会员价-L4会员,16-店铺会员价-L4会员,17-1号店会员价,18-电子书价,19-sam价,20-门店价,21-进口新客价,22-企业新人价,23-专属价,24-首单新人价,26-秒杀价,27-秒杀专享价,28-城市专享价,29-临期特卖,30-商场同款,31-商品定制价,32-亲子价,33-超市新人价,34-预售价,35-EDLP,36-砍后价,37-拼团价,38-陪伴价,39-xx人拼购价（使用7）,40-x件单价约xx,41-xx件单价,42-天天低价,43-低于30天均价,44-京东价,45-企业会员价,46-补贴价,47-套装价,48-区间价,49-百补补贴价,50-百补日常价,51-租赁价,52-划线价,53-拍卖当前价,54-起拍价,73-定期购预估总价,74-订金,75-区域专享价,76-星巴克会员价,77-医药商品单盒价,78-内购价,79-小时达新人到手价,-100-兜底值,0-小时购主要价格,81-直播间价格,82-神价,90-开普勒价,83-原始价,91-试用价,92-百补多人团价,93-秒送兑换券价（0元）,94-预售券后价,85-店铺会员到手价,86-plus会员价,87-渠道价,95-单促价,96-儿童价,97-婴儿价,98-火车票价格,99-直播专享价,100-直播专享价到手价,101-直播专享券到手价,102-预估新人价,103-未登录到手价,104-国补到手价,105-未领国补到手价,106-家政0元先享价,107-试算国补价,108-日常价,501-仅微信域红包到手价,109-加价,110-企业拉新,111-入会到手价,112-外卖月卡开卡价,113-补贴领后价,114-政府补贴价,115-租赁到手价,116-租赁原价,117-补贴到手价,118-门店新人价 */
firpricetype: | '1'| '2'| '3'| '4'| '5'| '6'| '7'| '8'| '9'| '10'| '11'| '12'| '13'| '14'| '15'| '16'| '17'| '18'| '19'| '20'| '21'| '22'| '23'| '24'| '26'| '27'| '28'| '29'| '30'| '31'| '32'| '33'| '34'| '35'| '36'| '37'| '38'| '39'| '40'| '41'| '42'| '43'| '44'| '45'| '46'| '47'| '48'| '49'| '50'| '51'| '52'| '53'| '54'| '73'| '74'| '75'| '76'| '77'| '78'| '79'| '-100'| '0'| '81'| '82'| '90'| '83'| '91'| '92'| '93'| '94'| '85'| '86'| '87'| '95'| '96'| '97'| '98'| '99'| '100'| '101'| '102'| '103'| '104'| '105'| '106'| '107'| '108'| '501'| '109'| '110'| '111'| '112'| '113'| '114'| '115'| '116'| '117'| '118',
/** 第二价格金额  */
secprice: number,
/** 第二价格类型 1-新人价,2-重逢价,3-粉丝价,4-闪购价,5-学生价,6-企业价,7-拼购价,8-家庭价,9-plus价,10-合约价,11-到手价,12-店铺会员价-L1会员,13-店铺会员价-L2会员,14-店铺会员价-L3会员,15-店铺会员价-L4会员,16-店铺会员价-L5会员,17-1号店会员价,18-电子书价,19-sam价,20-门店价,21-进口新客价,22-企业新人价,23-专属价,24-首单新人价,26-秒杀价,27-秒杀专享价,28-城市专享价,29-临期特卖,30-商场同款,31-商品定制价,32-亲子价,33-超市新人价,34-预售价,35-EDLP,36-砍后价,37-拼团价,38-陪伴价,40-X件单价约xx,41-xx件单价,42-天天低价,43-低于30天均价,44-京东价,45-企业会员价,46-补贴价,47-套装价,48-区间价,49-百补补贴价,50-百补日常价,51-租赁价,52-划线价,53-拍卖当前价,54-起拍价,73-定期购预估总价,74-订金（多阶段支付）,75-区域专享价,76-星巴克会员价,77-医药商品单盒价,78-内购价,79-小时达新人到手价,80-单规格价格,81-直播间价格,82-神价,83-原始价,90-开普勒价,91-试用价,84-第一件XX元/前n件XX元,92-百补多人团价,93-秒送兑换券价（0元）,94-预售券后价,95-单促价,96-儿童价,97-婴儿价,98-火车票价格,99-直播专享价,100-直播专享价到手价,101-直播专享券到手价,102-预估新人价,103-未登录到手价,104-国补到手价,105-国补拉新价,106-家政0元先享价,107-试算国补价,108-日常价,501-仅微信域红包到手价,109-加价,110-企业拉新,111-入会到手价,112-外卖月卡开卡价,113-补贴领后价,114-政府补贴价,115-租赁到手价,116-租赁原价,117-补贴到手价,118-门店新人价 */
secpricetype: | '1'| '2'| '3'| '4'| '5'| '6'| '7'| '8'| '9'| '10'| '11'| '12'| '13'| '14'| '15'| '16'| '17'| '18'| '19'| '20'| '21'| '22'| '23'| '24'| '26'| '27'| '28'| '29'| '30'| '31'| '32'| '33'| '34'| '35'| '36'| '37'| '38'| '40'| '41'| '42'| '43'| '44'| '45'| '46'| '47'| '48'| '49'| '50'| '51'| '52'| '53'| '54'| '73'| '74'| '75'| '76'| '77'| '78'| '79'| '80'| '81'| '82'| '83'| '90'| '91'| '84'| '92'| '93'| '94'| '95'| '96'| '97'| '98'| '99'| '100'| '101'| '102'| '103'| '104'| '105'| '106'| '107'| '108'| '501'| '109'| '110'| '111'| '112'| '113'| '114'| '115'| '116'| '117'| '118',
/** 榜单排名  */
rankNum: string,
/** 榜单id  */
rankId: string,
/** 榜单名称  */
rankName: string,
/** 位置id  */
rankPos: number,
/** 类型  */
type: string,
/** 分类等级  */
cateLevel: number,
/** tab名称  */
tabName: string}
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord,string>> = Object.freeze({
/** 榜单楼层查看更多曝光 */
  Activity_BestSellersHome_LookMoreExpo:'Activity_BestSellersHome_LookMoreExpo',
/** 榜单楼层曝光 */
  Activity_BestSellersHome_RankCard_Expo:'Activity_BestSellersHome_RankCard_Expo',
/** 翻页查看更多按钮曝光 */
  Activity_BestSellersHome_ViewMoreExpo:'Activity_BestSellersHome_ViewMoreExpo',
/** 榜单首页tab曝光 */
  Activity_BestSellersHome_Tab_Expo:'Activity_BestSellersHome_Tab_Expo',
/** 购物车按钮曝光 */
  Activity_BestSellersHome_Cart_Ep:'Activity_BestSellersHome_Cart_Ep',
/** 商品曝光 */
  Activity_BestSellersHome_ProductExpo:'Activity_BestSellersHome_ProductExpo',
})

interface IClickTrackParamsRecord {
  /** 榜单首页tab点击 */
Activity_BestSellersHome_Tab: {
/** tab名称  */
tabName: string,
/** 位置  */
index: number,
/** 分类等级  */
cateLevel: number}
  /** 榜单楼层查看更多点击 */
Activity_BestSellersHome_LookMore: {
/** 榜单id  */
rankId: string,
/** 榜单名称  */
rankName: string,
/** 位置id  */
rankPos: number,
/** 类型  */
type: string,
/** 商品id  */
skuid: Array<string>,
/** 分类等级  */
cateLevel: number,
/** tab名称  */
tabName: string,
/** 评分数量  */
scoreNum: string,
/** 位置  */
index: number}
  /** 翻页查看更多按钮点击 */
Activity_BestSellersHome_ViewMore: {
/** 页码  */
page: number}
  /** 榜单Tab折叠展开点击 */
Activity_BestSellersHome_Tab_Unfold_Click: {
/** tab名称  */
tabName: string,
/** 位置  */
index: number,
/** 点击后展开收起状态 0-收起,1-展开 */
isunfold: | '0'| '1'}
  /** 收藏按钮点击 */
Activity_BestSellers_Favorite: {
/** 榜单id  */
rankId: string,
/** 榜单名称  */
rankName: string,
/** 类型  */
type: string,
/** 评分数量  */
scoreNum: string,
/** 分类等级  */
cateLevel: number,
/** 商品id  */
skuId: string}
  /** 收藏按钮曝光 */
Activity_BestSellers_Favorite_Expo: {
/** 榜单id  */
rankId: string,
/** 榜单名称  */
rankName: string,
/** 类型  */
type: string,
/** 分类等级  */
cateLevel: number,
/** 评分数量  */
scoreNum: string,
/** 商品id  */
skuId: string,
/** 榜单排名  */
rankNum: string}
  /** 商品点击 */
Activity_BestSellersHome_Product: {
/** 商品id  */
skuid: string,
/** 第一价格金额  */
firprice: number,
/** 第一价格分类 1-新人价,2-重逢价,3-粉丝价,4-闪购价,5-学生价,6-企业价,7-拼购价,8-家庭价,9-plus价,10-合约价,11-到手价,12-店铺会员价-L1会员,13-店铺会员价-L2会员,14-店铺会员价-L3会员,15-店铺会员价-L4会员,16-店铺会员价-L4会员,17-1号店会员价,18-电子书价,19-sam价,20-门店价,21-进口新客价,22-企业新人价,23-专属价,24-首单新人价,26-秒杀价,27-秒杀专享价,28-城市专享价,29-临期特卖,30-商场同款,31-商品定制价,32-亲子价,33-超市新人价,34-预售价,35-EDLP,36-砍后价,37-拼团价,38-陪伴价,39-xx人拼购价（使用7）,40-x件单价约xx,41-xx件单价,42-天天低价,43-低于30天均价,44-京东价,45-企业会员价,46-补贴价,47-套装价,48-区间价,49-百补补贴价,50-百补日常价,51-租赁价,52-划线价,53-拍卖当前价,54-起拍价,73-定期购预估总价,74-订金,75-区域专享价,76-星巴克会员价,77-医药商品单盒价,78-内购价,79-小时达新人到手价,-100-兜底值,0-小时购主要价格,81-直播间价格,82-神价,90-开普勒价,83-原始价,91-试用价,92-百补多人团价,93-秒送兑换券价（0元）,94-预售券后价,85-店铺会员到手价,86-plus会员价,87-渠道价,95-单促价,96-儿童价,97-婴儿价,98-火车票价格,99-直播专享价,100-直播专享价到手价,101-直播专享券到手价,102-预估新人价,103-未登录到手价,104-国补到手价,105-未领国补到手价,106-家政0元先享价,107-试算国补价,108-日常价,501-仅微信域红包到手价,109-加价,110-企业拉新,111-入会到手价,112-外卖月卡开卡价,113-补贴领后价,114-政府补贴价,115-租赁到手价,116-租赁原价,117-补贴到手价,118-门店新人价 */
firpricetype: | '1'| '2'| '3'| '4'| '5'| '6'| '7'| '8'| '9'| '10'| '11'| '12'| '13'| '14'| '15'| '16'| '17'| '18'| '19'| '20'| '21'| '22'| '23'| '24'| '26'| '27'| '28'| '29'| '30'| '31'| '32'| '33'| '34'| '35'| '36'| '37'| '38'| '39'| '40'| '41'| '42'| '43'| '44'| '45'| '46'| '47'| '48'| '49'| '50'| '51'| '52'| '53'| '54'| '73'| '74'| '75'| '76'| '77'| '78'| '79'| '-100'| '0'| '81'| '82'| '90'| '83'| '91'| '92'| '93'| '94'| '85'| '86'| '87'| '95'| '96'| '97'| '98'| '99'| '100'| '101'| '102'| '103'| '104'| '105'| '106'| '107'| '108'| '501'| '109'| '110'| '111'| '112'| '113'| '114'| '115'| '116'| '117'| '118',
/** 第二价格金额  */
secprice: number,
/** 第二价格类型 1-新人价,2-重逢价,3-粉丝价,4-闪购价,5-学生价,6-企业价,7-拼购价,8-家庭价,9-plus价,10-合约价,11-到手价,12-店铺会员价-L1会员,13-店铺会员价-L2会员,14-店铺会员价-L3会员,15-店铺会员价-L4会员,16-店铺会员价-L5会员,17-1号店会员价,18-电子书价,19-sam价,20-门店价,21-进口新客价,22-企业新人价,23-专属价,24-首单新人价,26-秒杀价,27-秒杀专享价,28-城市专享价,29-临期特卖,30-商场同款,31-商品定制价,32-亲子价,33-超市新人价,34-预售价,35-EDLP,36-砍后价,37-拼团价,38-陪伴价,40-X件单价约xx,41-xx件单价,42-天天低价,43-低于30天均价,44-京东价,45-企业会员价,46-补贴价,47-套装价,48-区间价,49-百补补贴价,50-百补日常价,51-租赁价,52-划线价,53-拍卖当前价,54-起拍价,73-定期购预估总价,74-订金（多阶段支付）,75-区域专享价,76-星巴克会员价,77-医药商品单盒价,78-内购价,79-小时达新人到手价,80-单规格价格,81-直播间价格,82-神价,83-原始价,90-开普勒价,91-试用价,84-第一件XX元/前n件XX元,92-百补多人团价,93-秒送兑换券价（0元）,94-预售券后价,95-单促价,96-儿童价,97-婴儿价,98-火车票价格,99-直播专享价,100-直播专享价到手价,101-直播专享券到手价,102-预估新人价,103-未登录到手价,104-国补到手价,105-国补拉新价,106-家政0元先享价,107-试算国补价,108-日常价,501-仅微信域红包到手价,109-加价,110-企业拉新,111-入会到手价,112-外卖月卡开卡价,113-补贴领后价,114-政府补贴价,115-租赁到手价,116-租赁原价,117-补贴到手价,118-门店新人价 */
secpricetype: | '1'| '2'| '3'| '4'| '5'| '6'| '7'| '8'| '9'| '10'| '11'| '12'| '13'| '14'| '15'| '16'| '17'| '18'| '19'| '20'| '21'| '22'| '23'| '24'| '26'| '27'| '28'| '29'| '30'| '31'| '32'| '33'| '34'| '35'| '36'| '37'| '38'| '40'| '41'| '42'| '43'| '44'| '45'| '46'| '47'| '48'| '49'| '50'| '51'| '52'| '53'| '54'| '73'| '74'| '75'| '76'| '77'| '78'| '79'| '80'| '81'| '82'| '83'| '90'| '91'| '84'| '92'| '93'| '94'| '95'| '96'| '97'| '98'| '99'| '100'| '101'| '102'| '103'| '104'| '105'| '106'| '107'| '108'| '501'| '109'| '110'| '111'| '112'| '113'| '114'| '115'| '116'| '117'| '118',
/** 榜单id  */
rankId: string,
/** 榜单名称  */
rankName: string,
/** 榜单排名  */
rankNum: string,
/** 评分数量  */
scoreNum: string,
/** 分类等级  */
cateLevel: number,
/** 类型  */
type: string,
/** tab名称  */
tabName: string}
  /** 购物车按钮点击 */
Activity_BestSellersHome_Cart: {
/** 商品id  */
skuid: string,
/** 第一价格金额  */
firprice: number,
/** 第一价格分类 1-新人价,2-重逢价,3-粉丝价,4-闪购价,5-学生价,6-企业价,7-拼购价,8-家庭价,9-plus价,10-合约价,11-到手价,12-店铺会员价-L1会员,13-店铺会员价-L2会员,14-店铺会员价-L3会员,15-店铺会员价-L4会员,16-店铺会员价-L4会员,17-1号店会员价,18-电子书价,19-sam价,20-门店价,21-进口新客价,22-企业新人价,23-专属价,24-首单新人价,26-秒杀价,27-秒杀专享价,28-城市专享价,29-临期特卖,30-商场同款,31-商品定制价,32-亲子价,33-超市新人价,34-预售价,35-EDLP,36-砍后价,37-拼团价,38-陪伴价,39-xx人拼购价（使用7）,40-x件单价约xx,41-xx件单价,42-天天低价,43-低于30天均价,44-京东价,45-企业会员价,46-补贴价,47-套装价,48-区间价,49-百补补贴价,50-百补日常价,51-租赁价,52-划线价,53-拍卖当前价,54-起拍价,73-定期购预估总价,74-订金,75-区域专享价,76-星巴克会员价,77-医药商品单盒价,78-内购价,79-小时达新人到手价,-100-兜底值,0-小时购主要价格,81-直播间价格,82-神价,90-开普勒价,83-原始价,91-试用价,92-百补多人团价,93-秒送兑换券价（0元）,94-预售券后价,85-店铺会员到手价,86-plus会员价,87-渠道价,95-单促价,96-儿童价,97-婴儿价,98-火车票价格,99-直播专享价,100-直播专享价到手价,101-直播专享券到手价,102-预估新人价,103-未登录到手价,104-国补到手价,105-未领国补到手价,106-家政0元先享价,107-试算国补价,108-日常价,501-仅微信域红包到手价,109-加价,110-企业拉新,111-入会到手价,112-外卖月卡开卡价,113-补贴领后价,114-政府补贴价,115-租赁到手价,116-租赁原价,117-补贴到手价,118-门店新人价 */
firpricetype: | '1'| '2'| '3'| '4'| '5'| '6'| '7'| '8'| '9'| '10'| '11'| '12'| '13'| '14'| '15'| '16'| '17'| '18'| '19'| '20'| '21'| '22'| '23'| '24'| '26'| '27'| '28'| '29'| '30'| '31'| '32'| '33'| '34'| '35'| '36'| '37'| '38'| '39'| '40'| '41'| '42'| '43'| '44'| '45'| '46'| '47'| '48'| '49'| '50'| '51'| '52'| '53'| '54'| '73'| '74'| '75'| '76'| '77'| '78'| '79'| '-100'| '0'| '81'| '82'| '90'| '83'| '91'| '92'| '93'| '94'| '85'| '86'| '87'| '95'| '96'| '97'| '98'| '99'| '100'| '101'| '102'| '103'| '104'| '105'| '106'| '107'| '108'| '501'| '109'| '110'| '111'| '112'| '113'| '114'| '115'| '116'| '117'| '118',
/** 第二价格金额  */
secprice: number,
/** 第二价格类型 1-新人价,2-重逢价,3-粉丝价,4-闪购价,5-学生价,6-企业价,7-拼购价,8-家庭价,9-plus价,10-合约价,11-到手价,12-店铺会员价-L1会员,13-店铺会员价-L2会员,14-店铺会员价-L3会员,15-店铺会员价-L4会员,16-店铺会员价-L5会员,17-1号店会员价,18-电子书价,19-sam价,20-门店价,21-进口新客价,22-企业新人价,23-专属价,24-首单新人价,26-秒杀价,27-秒杀专享价,28-城市专享价,29-临期特卖,30-商场同款,31-商品定制价,32-亲子价,33-超市新人价,34-预售价,35-EDLP,36-砍后价,37-拼团价,38-陪伴价,40-X件单价约xx,41-xx件单价,42-天天低价,43-低于30天均价,44-京东价,45-企业会员价,46-补贴价,47-套装价,48-区间价,49-百补补贴价,50-百补日常价,51-租赁价,52-划线价,53-拍卖当前价,54-起拍价,73-定期购预估总价,74-订金（多阶段支付）,75-区域专享价,76-星巴克会员价,77-医药商品单盒价,78-内购价,79-小时达新人到手价,80-单规格价格,81-直播间价格,82-神价,83-原始价,90-开普勒价,91-试用价,84-第一件XX元/前n件XX元,92-百补多人团价,93-秒送兑换券价（0元）,94-预售券后价,95-单促价,96-儿童价,97-婴儿价,98-火车票价格,99-直播专享价,100-直播专享价到手价,101-直播专享券到手价,102-预估新人价,103-未登录到手价,104-国补到手价,105-国补拉新价,106-家政0元先享价,107-试算国补价,108-日常价,501-仅微信域红包到手价,109-加价,110-企业拉新,111-入会到手价,112-外卖月卡开卡价,113-补贴领后价,114-政府补贴价,115-租赁到手价,116-租赁原价,117-补贴到手价,118-门店新人价 */
secpricetype: | '1'| '2'| '3'| '4'| '5'| '6'| '7'| '8'| '9'| '10'| '11'| '12'| '13'| '14'| '15'| '16'| '17'| '18'| '19'| '20'| '21'| '22'| '23'| '24'| '26'| '27'| '28'| '29'| '30'| '31'| '32'| '33'| '34'| '35'| '36'| '37'| '38'| '40'| '41'| '42'| '43'| '44'| '45'| '46'| '47'| '48'| '49'| '50'| '51'| '52'| '53'| '54'| '73'| '74'| '75'| '76'| '77'| '78'| '79'| '80'| '81'| '82'| '83'| '90'| '91'| '84'| '92'| '93'| '94'| '95'| '96'| '97'| '98'| '99'| '100'| '101'| '102'| '103'| '104'| '105'| '106'| '107'| '108'| '501'| '109'| '110'| '111'| '112'| '113'| '114'| '115'| '116'| '117'| '118',
/** 榜单排名  */
rankNum: string,
/** 榜单名称  */
rankName: string,
/** 分类等级  */
cateLevel: number,
/** 类型  */
type: string,
/** tab名称  */
tabName: string,
/** 榜单id  */
rankId: string}
}

const sendClickTrack = {
  /** 点击事件上报-榜单首页tab点击 */
Activity_BestSellersHome_Tab: (json_param: IClickTrackParamsRecord['Activity_BestSellersHome_Tab']) => {
    eventTrackingUtils.submitCL({event_id:'Activity_BestSellersHome_Tab',json_param});
  },
  /** 点击事件上报-榜单楼层查看更多点击 */
Activity_BestSellersHome_LookMore: (json_param: IClickTrackParamsRecord['Activity_BestSellersHome_LookMore']) => {
    eventTrackingUtils.submitCL({event_id:'Activity_BestSellersHome_LookMore',json_param});
  },
  /** 点击事件上报-翻页查看更多按钮点击 */
Activity_BestSellersHome_ViewMore: (json_param: IClickTrackParamsRecord['Activity_BestSellersHome_ViewMore']) => {
    eventTrackingUtils.submitCL({event_id:'Activity_BestSellersHome_ViewMore',json_param});
  },
  /** 点击事件上报-榜单Tab折叠展开点击 */
Activity_BestSellersHome_Tab_Unfold_Click: (json_param: IClickTrackParamsRecord['Activity_BestSellersHome_Tab_Unfold_Click']) => {
    eventTrackingUtils.submitCL({event_id:'Activity_BestSellersHome_Tab_Unfold_Click',json_param});
  },
  /** 点击事件上报-收藏按钮点击 */
Activity_BestSellers_Favorite: (json_param: IClickTrackParamsRecord['Activity_BestSellers_Favorite']) => {
    eventTrackingUtils.submitCL({event_id:'Activity_BestSellers_Favorite',json_param});
  },
  /** 点击事件上报-收藏按钮曝光 */
Activity_BestSellers_Favorite_Expo: (json_param: IClickTrackParamsRecord['Activity_BestSellers_Favorite_Expo']) => {
    eventTrackingUtils.submitCL({event_id:'Activity_BestSellers_Favorite_Expo',json_param});
  },
  /** 点击事件上报-商品点击 */
Activity_BestSellersHome_Product: (json_param: IClickTrackParamsRecord['Activity_BestSellersHome_Product']) => {
    eventTrackingUtils.submitCL({event_id:'Activity_BestSellersHome_Product',json_param});
  },
  /** 点击事件上报-购物车按钮点击 */
Activity_BestSellersHome_Cart: (json_param: IClickTrackParamsRecord['Activity_BestSellersHome_Cart']) => {
    eventTrackingUtils.submitCL({event_id:'Activity_BestSellersHome_Cart',json_param});
  },
}

export {
  EXPOSURE_RECORD,
  sendClickTrack,
  sendPv,
}
export type {
  IExpoTrackParamsRecord,
}